import {
    GET_STRELLATV_SUCCESS,
    GET_STRELLATV_FAIL
} from './types'
import axios from 'axios';


export const get_strellatv = () => async dispatch => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}api/strellatv`);
        console.log("res",res);
        if (res.status === 200) {
            dispatch({
                type: GET_STRELLATV_SUCCESS,
                payload: res.data.data
            });
        } else {
            dispatch({
                type: GET_STRELLATV_FAIL
            });
        }
    } catch (err) {
        console.log("err",err);
        dispatch({
            type: GET_STRELLATV_FAIL
        });
    }
};